export default __webpack_public_path__ + "static/travelpaylater-8461e75e4ccd546cca37728a6b436c64.png";